module.exports = __webpack_public_path__ + "img/EnumaGroupPhoto1600-2.1d4f86d2.jpeg";